var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_912_2805)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0845 63.3075C13.7342 81.4853 8.80776 102.975 11.2469 125.359C17.409 181.909 68.2472 222.757 124.797 216.595C155.447 213.255 181.484 196.791 197.924 173.407L24.0845 63.3075ZM203.196 165.095C213.546 146.917 218.472 125.428 216.033 103.044C209.871 46.4939 159.033 5.64629 102.483 11.8084C71.8331 15.1481 45.7963 31.6115 29.3565 54.9951L203.196 165.095Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.569 169.448C193.314 180.864 183.881 190.739 172.81 198.509C161.739 206.279 149.245 211.793 136.043 214.735C122.841 217.677 109.188 217.99 95.8651 215.655C82.542 213.321 69.8091 208.386 58.3934 201.13C46.9777 193.875 37.1028 184.443 29.3325 173.371C21.5622 162.3 16.0487 149.807 13.1067 136.604C10.1647 123.402 9.85189 109.75 12.1861 96.4265C14.5204 83.1034 19.4559 70.3705 26.711 58.9549L113.64 114.201L200.569 169.448Z",
    fill: "url(#paint0_linear_912_2805)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.569 169.448C193.314 180.864 183.881 190.739 172.81 198.509C161.739 206.279 149.245 211.793 136.043 214.735C122.841 217.677 109.188 217.99 95.8651 215.655C82.542 213.321 69.8091 208.386 58.3934 201.13C46.9777 193.875 37.1028 184.443 29.3325 173.371C21.5622 162.3 16.0487 149.807 13.1067 136.604C10.1647 123.402 9.85189 109.75 12.1861 96.4265C14.5204 83.1034 19.4559 70.3705 26.711 58.9549L113.64 114.201L200.569 169.448Z",
    fill: "url(#paint1_linear_912_2805)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_912_2805",
    x: 0.632812,
    y: 1.19336,
    width: 226.016,
    height: 226.016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_912_2805"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_2805",
    x1: 11.2469,
    y1: 125.359,
    x2: 216.033,
    y2: 103.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1149DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_912_2805",
    x1: 11.2469,
    y1: 125.359,
    x2: 216.033,
    y2: 103.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394DF",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3432AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBall);
export default __webpack_public_path__ + "static/media/contactBall.3d5dd6bb6d2ab2306415678ea5dd2d05.svg";
export { ForwardRef as ReactComponent };